module.exports = __webpack_public_path__ + "static/media/close.0ca53722.svg";